import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

interface PaymentLoadingModalProps {
  open: boolean;
  isPixPayment: boolean;
}

export function PaymentLoadingModal({ open, isPixPayment }: PaymentLoadingModalProps) {
  const loadingMessage = isPixPayment 
    ? "🔗 Gerando sua chave de pagamento PIX… quase pronto! 😊"
    : "💳 Estamos confirmando o pagamento com o seu banco… isso pode levar alguns instantes! 😊";

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md">
        <div className="flex flex-col items-center justify-center p-6 text-center">
          <Loader2 className="h-16 w-16 animate-spin text-primary mb-6" />
          <div className="space-y-2">
            <h3 className="text-lg font-semibold">Processando pagamento</h3>
            <p className="text-muted-foreground text-sm">
              {loadingMessage}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}